import React from "react";
import styles from "./styles.module.css";
import clsx from "clsx";
import { isEmpty } from "lodash";
import ImageComponent from "../../ImageComponent";
// import leftIcon from "../../../assets/star-icon.svg";
import { useSelector } from "react-redux";
import { getTextForGameFeed, getTurnCount } from "../store/actions";
import { _find, _isEmpty } from "../../../utils/helpers/zupeeLodash";

const GameFeed:React.FC = () => {

  const textForGameFeed = useSelector(getTextForGameFeed);
  const turnCount = useSelector(getTurnCount);
  const currentMove = turnCount;

  const currentTextFeed = _find(
    textForGameFeed,
    item => currentMove >= parseInt(item?.startMove || '0') && currentMove <= parseInt(item?.endMove || '0')
  );

  const { leftImage, rightImage, text } = currentTextFeed || {};

  if (_isEmpty(text)) {
    return null
  }

  return(
    <>
      <div className={clsx(styles.gameFeedContent, "flex alignItemCenter justifyContentCenter")}>
        {!isEmpty(leftImage) && 
        <ImageComponent
          src={leftImage || ''}
          alt="icon"
          className={clsx(styles.icon)}
        />}
        <div className={clsx(styles.content, "fontSizeXs fontWeightRegular")}>{text}</div>
        {/* <div className={clsx(styles.scoreValue, "fontColorWhite fontWeightBolder fontSizeSm")}>560</div> */}
        {!isEmpty(rightImage) && 
        <ImageComponent
          src={rightImage || ''}
          alt="icon"
          className={clsx(styles.icon)}
        />}
      </div>
    </>
  )
}
export default GameFeed;